import { z } from 'zod';
const TestSuiteCategoryFilterSchema = z.enum(['ALL', 'PLANNED_REGULAR', 'PLANNED_SPOT', 'UNPLANNED']);
export type TestSuiteCategoryFilter = z.infer<typeof TestSuiteCategoryFilterSchema>;
const TestSuiteStatusFilterSchema = z.enum(['PLANNING', 'RUNNING', 'PAUSED', 'DONE']);
export type TestSuiteStatusFilter = z.infer<typeof TestSuiteStatusFilterSchema>;
const TestSuiteQualityStatusFilterSchema = z.enum(['NONE', 'SOME', 'UNTOUCHED', 'CRITICAL']);
export type TestSuiteQualityStatusFilter = z.infer<typeof TestSuiteQualityStatusFilterSchema>;
export const TestSuiteTableFilterSchema = z.object({
  category: TestSuiteCategoryFilterSchema.default('PLANNED_REGULAR'),
  status: TestSuiteStatusFilterSchema.optional(),
  qualityStatus: TestSuiteQualityStatusFilterSchema.optional(),
  productId: z.string().optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100)
});